import { loadScript } from '~utils/loadScript';

export type AppleSignInResponse = {
  authorization: { id_token: string; code: string };
  user?: { name?: { firstName?: string; lastName?: string } };
};

type AppleIDGlobal = {
  auth: {
    init(config: {
      clientId: string;
      scope: string;
      redirectURI: string;
      usePopup: boolean;
    }): void;
    signIn(): Promise<AppleSignInResponse>;
  };
};

declare global {
  interface Window {
    AppleID?: AppleIDGlobal;
  }
}

export const loadAppleSdk = async (): Promise<AppleIDGlobal> => {
  await loadScript(
    'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
  );
  if (!window.AppleID) throw new Error('AppleID SDK unavailable');
  return window.AppleID;
};
